module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-banner-social-0d8e09adefa7c0926be5ba630b8f7fbd.jpg";